<template>
   <div class="jionPicker">
       申请成为选菜妈妈宣传页  -- 保留页面后续开发
   </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>